import { AuthButton, AuthCard, AuthLayout } from "./Shared"
import { Spacer } from "../atoms/Atoms"
import { CenteredLoadingIndicator } from "../molecules/Molecules"
import { useFormContext } from "react-hook-form"
import React, { useContext } from "react"
import L10n from "../../../lib/carrot-l10n"
import { ResetPasswordContext } from "../../containers/login/ResetPasswordContainer"
import { Body } from "../atoms/Bodies"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { H1 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const PasswordInput = () => {
  const { register, errors } = useFormContext()

  return (
    <CompleteFormInput
      ref={register({})}
      errors={errors}
      showValidation={false}
      name="password"
      label="Password"
      type="password"
      autoFocus
    />
  )
}

const ConfirmPasswordInput = () => {
  const { register, errors } = useFormContext()

  return (
    <CompleteFormInput
      ref={register}
      errors={errors}
      showValidation={false}
      name="confirmPassword"
      label="Confirm password"
      type="password"
    />
  )
}

const GuidErrorMessage = () => (
  <>
    <Spacer height={1} />
    <Body align="tc" color="invalid-red">
      {l`client.resetPasswordError`}
    </Body>
    <Spacer height={1} />
  </>
)

const ResetPasswordHeader = () => (
  <div className="flex justify-center mt35">
    <H1>{l`client.resetPassword`}</H1>
  </div>
)

const ResetPasswordErrors = () => {
  const {
    errors: { password }
  } = useFormContext()

  return (
    <div className="mt2 tc flex justify-center w-100">
      <div style={{ width: 320 }}>
        {password ? (
          <Body color="invalid-red">{password.message}</Body>
        ) : (
          <Body color="black-80">{l`client.pleaseEnterTheNewPassword`}</Body>
        )}
      </div>
    </div>
  )
}

const ResetPasswordButton = () => {
  const { onSubmit, isSubmitting } = useContext(ResetPasswordContext)
  return (
    <div className="flex flex-auto justify-center">
      <AuthButton onClick={!isSubmitting ? onSubmit : null} enabled={!isSubmitting}>
        {isSubmitting ? l`client.submitting` : l`client.resetPassword`}
      </AuthButton>
    </div>
  )
}

const ResetPasswordLoading = () => (
  <div className="flex flex-column items-center">
    <Spacer height={0.5} />
    <CenteredLoadingIndicator />
  </div>
)

const ResetPasswordForm = () => (
  <>
    <ResetPasswordHeader />
    <Spacer height={0.5} />
    <ResetPasswordErrors />
    <Spacer height={1.5} />
    <PasswordInput />
    <Spacer height={1.5} />
    <ConfirmPasswordInput />
    <Spacer height={1.5} />
    <ResetPasswordButton />
    <Spacer height={0.5} />
  </>
)

const ResetPassword = () => {
  const { onSubmit, isLoaded, isGuidError } = useContext(ResetPasswordContext)

  return (
    <AuthLayout title={l`client.login`}>
      <AuthCard onSubmit={onSubmit}>
        <Spacer height={2.5} />
        {(() => {
          if (isGuidError) return <GuidErrorMessage />
          if (isLoaded) return <ResetPasswordForm />
          return <ResetPasswordLoading />
        })()}
      </AuthCard>
    </AuthLayout>
  )
}

export default ResetPassword
